import { useMutation, useQuery } from '@tanstack/react-query'
import { addRole, updateRole, updateRoleStatus, deleteRole, getRoleList, getSpinnerRoleList } from '../api/roles'

// Roles
export const useGetRoleList = (queryParams = '') => {
    return useQuery({
        queryKey: ['roles', queryParams],
        queryFn: () => getRoleList(queryParams),
    });
};

export const useGetSpinnerRoleList = (queryParams = '') => {
    return useQuery({
        queryKey: ['spinner_roles', queryParams],
        queryFn: () => getSpinnerRoleList(queryParams)
    });
};

export const useAddRole = () => {
    return useMutation({
        mutationFn: addRole
    })
};

export const useUpdateRole = () => {
    return useMutation({
        mutationFn: updateRole
    })
};

export const useUpdateRoleStatus = () => {
    return useMutation({
        mutationFn: updateRoleStatus
    })
};

export const useDeleteRole = () => {
    return useMutation({
        mutationFn: deleteRole
    })
};